import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ExploreRap = styled.div`
  margin-top: 200px;
  .search-input input {
    background: #ffffff;
    border: 0.7px solid #bac0d4b2;
    width: 400px;
    height: 44px;
    border-radius: 100px;
    padding-left: 30px;
  }
  .search-input {
    position: relative;
    width: 400px;
  }
  .search-icon {
    position: absolute;
    top: 13px;
    left: 10px;
  }
  .filter {
    background: #ffffff;
    border: 0.7px solid #bac0d4b2;
    width: 102px;
    height: 40px;
    border-radius: 100px;
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
  }
  .input-filter-div {
    background: #f7f7f7;
    border-radius: 100px;
    padding: 10px;
    display: flex;
    gap: 20px;
    width: fit-content;
  }
  .explore-1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .explore-1 h2 {
    color: #060b13;
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    line-height: 45px;
  }
  .explore-1 p {
    color: #363d4f;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 20px;
  }
  .explore-2-sub-1 p {
    color: #363d4f;
    font-size: 16px;
    font-weight: 400;
  }
  .explore-2-sub-1 h4 {
    color: #060b13;
    font-size: 30px;
    font-weight: 700;
  }
  .explore-2-sub-1 {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .events-text-divs {
    padding: 20px;
    border-radius: 5px;
    height: 382px;

    width: 286px;

    gap: 10px;
    cursor: pointer;
  }
  .push-down-event {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .events-text-divs h4 {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    line-height: 17px;
    max-width: 183px;
  }
  .events-text-divs p {
    color: #dcdcdc;
    font-size: 12px;
    font-weight: 400;
  }
  .down-event-text {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .events-2 {
    border: 0.7px solid #bac0d499;
    border-radius: 20px;
    padding: 24px 32px;
    margin-top: 30px;
  }
  .down-event-text-div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .the-play-audion-icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80%;
  }
  .event-round {
    width: 42px;
    border-radius: 50%;
    height: 42px;
  }
  .explore-2-sub-2 {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(4, 1fr);
  }
  .padding-move {
    padding-left: 100px;
    padding-right: 100px;
  }
  .see-more-btn {
    border-left: 2px;
    border-right: 5px;
    border-bottom: 5px;
    border-top: 2px;
    border-style: solid;
    text-decoration: none;
    border-color: #060b13;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 55px;
    border-radius: 100px;
    color: #060b13;
    font-size: 16px;
    font-weight: 600;
    margin: auto;
  }
 
  .all-explore-divs {
    display: flex;
    flex-direction: column;
    gap: 50px;
    margin-bottom: 100px;
  }
  .explore-2 {
    margin-top: 20px;
  }

  @media (max-width: 1300px) {
    .padding-move {
      padding-right: 50px !important;
      padding-left: 50px !important;
    }
  }

  @media (max-width: 1024px) {
    .padding-move {
      padding-right: 70px !important;
      padding-left: 70px !important;
    }
  }
  @media (max-width: 992px) {
    .padding-move {
      padding-right: 60px !important;
      padding-left: 60px !important;
    }
  }
  @media (max-width: 767px) {
    .padding-move {
      padding-right: 50px !important;
      padding-left: 50px !important;
    }
  }
  @media (max-width: 678px) {
    .padding-move {
      padding-right: 30px !important;
      padding-left: 30px !important;
    }
  }

  @media (max-width: 1250px) {
    .explore-2-sub-2 {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (max-width: 992px) {
    .explore-2-sub-2 {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 678px) {
    .explore-2-sub-2 {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  @media (max-width: 550px) {
    .input-filter-div {
      flex-wrap: wrap;
      background: #ffffff;
    }
    .search-input input {
      width: 300px;
    }
    .search-input {
    width: 300px;
  }
  }
  @media (max-width: 350px) {
    .events-text-divs {
      width: 250px;
    }
    .search-input input {
      width: 250px;
    }
    .search-input {
    width: 250px;
  }
  }
`;

const Explore = () => {
  const trending = [
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/trend-1.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/trend-2.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/trend-3.png",
      color: "#98081C",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/trend-4.png",
      color: "#4A4A4A",
    },
  ];
  const recommend = [
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/reco-1.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/reco-2.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/reco-3.png",
      color: "#98081C",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/reco-4.png",
      color: "#4A4A4A",
    },
  ];
  const feature = [
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/fea-1.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/fea-2.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/fea-3.png",
      color: "#98081C",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/fea-4.png",
      color: "#4A4A4A",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/fea-5.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/fea-6.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/fea-7.png",
      color: "#98081C",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/fea-8.png",
      color: "#4A4A4A",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/fea-9.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/fea-10.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/fea-11.png",
      color: "#98081C",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/fea-12.png",
      color: "#4A4A4A",
    },
  ];
  return (
    <ExploreRap>
      <div className="explore-1 padding-move">
        <h2>Discover streams</h2>
        <p>Uncover voices worth hearing and people worth following.</p>
        <div className="input-filter-div">
          <div className="search-input">
            <Icon className="search-icon"
              width="20px"
              height="20px"
              icon="material-symbols:search-rounded"
              style={{ color: "#363D4F" }}
            />
            <input type="text" placeholder="Search" />
          </div>
          <div className="filter">
            <img src="/images/filt.svg" alt="" />
            <p>Filter</p>
          </div>
        </div>
      </div>
      <div className="all-explore-divs">
        <div className="explore-2 padding-move">
          <div className="explore-2-sub-1">
            <h4>Trending</h4>
            <p>Popular streams gaining tractions</p>
          </div>
          <div className="explore-2-sub-2">
            {trending.map((event, index) => (
              <div
                className="events-text-divs "
                key={index}
                style={{
                  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "cover",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    height: "100%",
                  }}
                >
                  <div className="the-play-audion-icon">
                    <img src="/images/audio_icon.png" alt="" />
                  </div>
                  <div className="push-down-event">
                    <div className="down-event-text-div">
                      <div
                        className="event-round"
                        style={{
                          background: `${event.color}`,
                        }}
                      ></div>
                      <div className="down-event-text">
                        <h4>{event.title}</h4>
                        <p>{event.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="explore-2 padding-move">
          <div className="explore-2-sub-1">
            <h4>Recommended for you</h4>
            <p>Our picks for you based on your listening</p>
          </div>
          <div className="explore-2-sub-2">
            {recommend.map((event, index) => (
              <div
                className="events-text-divs "
                key={index}
                style={{
                  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "cover",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    height: "100%",
                  }}
                >
                  <div className="the-play-audion-icon">
                    <img src="/images/audio_icon.png" alt="" />
                  </div>
                  <div className="push-down-event">
                    <div className="down-event-text-div">
                      <div
                        className="event-round"
                        style={{
                          background: `${event.color}`,
                        }}
                      ></div>
                      <div className="down-event-text">
                        <h4>{event.title}</h4>
                        <p>{event.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="explore-2 padding-move">
          <div className="explore-2-sub-1">
            <h4>Featured</h4>
            <p>Curated selections you might like</p>
          </div>
          <div className="explore-2-sub-2">
            {feature.map((event, index) => (
              <div
                className="events-text-divs "
                key={index}
                style={{
                  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "cover",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    height: "100%",
                  }}
                >
                  <div className="the-play-audion-icon">
                    <img src="/images/audio_icon.png" alt="" />
                  </div>
                  <div className="push-down-event">
                    <div className="down-event-text-div">
                      <div
                        className="event-round"
                        style={{
                          background: `${event.color}`,
                        }}
                      ></div>
                      <div className="down-event-text">
                        <h4>{event.title}</h4>
                        <p>{event.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Link className="see-more-btn">See More</Link>
      </div>
    </ExploreRap>
  );
};

export default Explore;
